import CheckConnection from "@/Services/Connection";

import { danger } from "@/Utils/Debug";

class CheckConnectionActionHandler {
  constructor() {}

  public async handle(): Promise<boolean> {
    try {
      return CheckConnection();
    } catch (e) {
      danger("Error check connection");

      return false;
    }
  }
}

export default CheckConnectionActionHandler;
